const MAX_EXPIRES = 10 * 365 * 24 * 60 * 60 * 1000

const COOKIE_DOMAIN = 'arzamas.academy'

export default class CookieAccessor {
  static getCookie(key) {
    const cookie = require('cookies-js')
    return cookie.get(key)
  }

  static setCookie(key, value, expires_in = MAX_EXPIRES) {
    const cookie = require('cookies-js')
    let expires = new Date()
    expires.setTime(expires.valueOf() + expires_in)
    cookie.set(key, value, { expires, domain: COOKIE_DOMAIN })
  }

  static expireCookie(key) {
    const cookie = require('cookies-js')
    cookie.expire(key, { domain: COOKIE_DOMAIN })
  }
}
